<template>
  <selector
    draggable-group="questions"
    item-name-plural="questions"
    item-name="question"
    v-model="questions"
    :can-add="true"
    :category-list="questionCategoryWithQuestionsList"
    :disabled-ids="selectorDisabledQuestionIds"
    :is-fixed="isFixed"
    :is-editable="isEditable"
    :search-text="selectorQuestionSearchText"
    :selected-category-id="selectorSelectedQuestionCategory"
    @onItemAdd="handleAddQuestion"
    @onItemEdit="handleEditQuestion"
    @onChangeCategory="handleSelectCategory"
    @onCreate="handleCreateQuestion"
    @onLoadMore="handleLoadMore"
    @onResetFilters="handleResetFilters"
    @onChangeSearchText="handleSearchText"
  ></selector>
</template>

<script>
import { debounce } from 'lodash';
import { mapGetters, mapState } from 'vuex';

import * as surveyBuilderTypes from '@/store/modules/surveybuilder/mutation-types';

import Selector from './Selector';

const DEBOUNCE_DELAY = 600;

export default {
  name: 'QuestionSelector',
  components: {
    Selector,
  },
  props: {
    isFixed: {
      type: Boolean,
      default: false,
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState('surveybuilder', [
      'questionList',
      'questionsLoading',
      'questionsPage',
      'questionCategoryWithQuestionsList',
      'selectorSelectedQuestionCategory',
      'selectorQuestionSearchText',
    ]),
    ...mapState('user', ['me']),
    ...mapGetters('surveybuilder', ['selectorDisabledQuestionIds']),

    questions() {
      return this.questionList
        .map(question => {
          if (question.isGlobal) {
            return {
              ...question,
              isEditable: this.me.is_staff,
            };
          }
          return { ...question, isEditable: true };
        })
        .filter(question => {
          // Remove global questions that already have an exact version in company scope
          if (question.isGlobal) {
            const matchFields = ['title', 'questionType', 'categoryId'];
            const exactQuestions = this.questionList.filter(
              q => !q.isGlobal && matchFields.every(field => q[field] === question[field]),
            );
            return exactQuestions.length === 0;
          }
          return true;
        });
    },
  },
  methods: {
    handleAddQuestion(question) {
      this.$store.dispatch('surveybuilder/canvasAddQuestion', question);
    },

    handleEditQuestion(question) {
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.SET_QUESTION_DIALOG_FORM}`, question);
      this.$store.commit(
        `surveybuilder/${surveyBuilderTypes.SET_QUESTION_DIALOG_VISIBILITY}`,
        true,
      );
    },

    handleSelectCategory(categoryId) {
      this.$store.dispatch('surveybuilder/selectorSelectQuestionCategory', categoryId);
      this.$store.dispatch('surveybuilder/getQuestions');
    },

    handleCreateQuestion() {
      this.$store.commit(
        `surveybuilder/${surveyBuilderTypes.SET_QUESTION_DIALOG_VISIBILITY}`,
        true,
      );
    },

    handleSearchText(text) {
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.SET_SELECTOR_QUESTION_TEXT}`, text);
      this.handleDebounceGetQuestions();
    },

    handleResetFilters() {
      this.$store.commit(`surveybuilder/${surveyBuilderTypes.RESET_SELECTOR_QUESTION_FILTERS}`);
      this.$store.dispatch('surveybuilder/getQuestions');
    },

    // eslint-disable-next-line
    handleDebounceGetQuestions: debounce(function() {
      this.$store.dispatch('surveybuilder/getQuestions');
    }, DEBOUNCE_DELAY),

    handleLoadMore() {
      if (this.questionList.length && !this.questionsLoading) {
        this.$store.dispatch('surveybuilder/getMoreQuestions');
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// QuestionSelector.vue?041a1d5e